<script setup>
const props = defineProps({
  year: {
    type: Number,
    default: () => new Date().getFullYear(),
  },
  month: {
    type: Number,
    default: () => new Date().getMonth() + 1,
  },
  is_approved: [String, Boolean],
});

const emit = defineEmits(['setYear', 'setMonth', 'setIsApproved']);

const options = [
  { label: 'all', value: 'all' },
  { label: 'waiting', value: 'null' },
  { label: 'approved', value: true },
  { label: 'reject', value: false },
];

const MONTH_NAMES = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

function setYear(operator) {
  emit('setYear', operator);
}

function setMonth(e) {
  emit('setMonth', e.target.value);
}
function setIsApproved(e) {
  emit('setIsApproved', e.target.value);
}
</script>

<template>
  <div class="grid w-full grid-cols-1 gap-4">
    <div class="grid items-center grid-cols-3">
      <div class="text-center">
        <button
          @click="setYear('-')"
          class="px-2 py-1 text-center text-white bg-indigo-400 rounded"
        >
          ◀︎
        </button>
      </div>
      <div class="text-lg font-bold text-center">
        {{ year }}
      </div>
      <div class="text-center">
        <button
          @click="setYear('+')"
          class="px-2 py-1 text-center text-white bg-indigo-400 rounded"
        >
          ▶︎︎
        </button>
      </div>
    </div>
    <select
      class="w-full border border-gray-400 rounded"
      @change="setMonth"
      :selected="month"
      :value="month"
    >
      <option v-for="(label, index) in MONTH_NAMES" :key="label" :value="index + 1">
        {{ label }}
      </option>
    </select>
    <!-- <div class="grid grid-cols-2 gap-2">
      <select class="w-full border border-gray-400 rounded" @change="setMonth"  :selected="month" :value="month">
        <option v-for="(label, index) in MONTH_NAMES" :key="label" :value="index + 1">
            {{ label }}
        </option>
      </select>
      <select class="w-full border border-gray-400 rounded" @change="setIsApproved">
        <option v-for="option in options" :key="option.label" :value="option.value">
          {{ option.label }}
        </option>
      </select>
    </div> -->
  </div>
</template>
